import {environment} from "./environment";
import {IAppConfig} from "../app/Redux/selector.state";

export class EdsEnvConfig {

  private appConfig: IAppConfig | null = null;

  private _remoteSVR  = '/';
  private get _serverCAS(): string {return this._remoteSVR; }
  private get _edsService(): string { return '/edsService3/'; }

  production            = environment.production;
  examplesPrj           = 'assets/demo_files/list.xml';
  edsLedDb              = 'assets/catalogs/led_db.xml';

  get login_url(): string              {return `${this.appConfig.AuthUrl}/oauth2/authorize?idp_identifier=${this.appConfig.AuthIDP}&response_type=code&client_id=${this.appConfig.ClientID}&redirect_uri=`; }
  user_token(code: string, redirectUri: string): string     {return `${this.appConfig.AuthUrl}/oauth2/token?grant_type=authorization_code&code=${code}&client_id=${this.appConfig.ClientID}&redirect_uri=${redirectUri}`; }
  refresh_token(refresh_token: string): string {return `${this.appConfig.AuthUrl}/oauth2/token?grant_type=refresh_token&client_id=${this.appConfig.ClientID}&refresh_token=${refresh_token}`; }

  get edsUrl():         string {return this._serverCAS ; }
  get addItem():        string {return this._edsService + 'add-item'; }
  get userFile():       string {return this._edsService + 'item-content/'; }
  get removeUserFile(): string {return this._edsService + 'delete/'; }
  // get userLogged():     string {return this._serverUrl + 'edsService2/' + 'user.xml?key='; }
  // get listUserFiles():      string {return '/assets' + this._edsService + 'all-items?key='; }
  get listUserFiles():  string {return this._edsService + 'all-items?key='; }
  get renameResource(): string {return this._edsService + 'rename/'; }
  // get logAction():      string {return this._edsService + 'Action?action=log&event='; }
  get edsService():     string {return this._edsService; }
  get edsServerURL():   string {return this._serverCAS; }
  get logout():         string {return this._serverCAS + 'cas/logout'; }

  updateConfiguration(appConfig: IAppConfig) {
    this._remoteSVR = appConfig.edsService;
    this.appConfig = appConfig;
  }
}

export const edsEnvConfiguration = new EdsEnvConfig();
